<template>
  <div class="footer-main">
    <div class="container flex justify-between items-center h-[72px]">
      <div class="flex items-center">
        <a href="">关于我们</a>
        <a href="" class="ml-[20px]">联系我们</a>
      </div>
      <div>Copyright@2024电子口岸IC卡Rights Reserved浙ICP备2024089909号-4</div>
    </div>
  </div>
</template>

<script setup></script>

<style lang="scss" scoped></style>
